import Vue from 'vue'
import supplyConfigTransformer from '../../../transformers/catalog/warehouse/supplyConfig'

/**
 * @author jorge nuñez lópez <>
 *
 * Fetch supply configurations
 * @return {object}
 */

export default (warehouseId, params = {}) =>
  Vue.$http.get(`iwarehouse/supply-list-create/${warehouseId}/`, { params })
    .then(({ data }) => {
      const dataTransformed = supplyConfigTransformer.fetchCollection(data)
      return dataTransformed
    })


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchSupplyConfig.js